const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
class Observer {
  constructor () {
    this.setFunction = this.setFunction.bind(this)
    this.runFunction = this.runFunction.bind(this)
  }
  eventEmitter = {
    list: {},
    on: function(event, fn) {
      let _this = this
        // 如果对象中没有对应的 event 值，也就是说明没有订阅过，就给 event 创建个缓存列表
        // 如有对象中有相应的 event 值，把 fn 添加到对应 event 的缓存列表里

      // // 此逻辑开放普惠H5，逻辑并不完善，会存储很多订阅方法在里面
      // if (systemconf.isH5Plus) {
      //   let fns = _this.list[event]
      //   if (fns && fns.length) {  // 当订阅者列表存在时，需要添加fn, 并且没有在订阅列表中找到
      //     if (!fns.find(i => i === fn)) {
      //       fns.push(fn)
      //     }
      //   } else { // 不存在直接存储
      //     fns = [fn]
      //   }
      //   _this.list[event] = fns
      // } else {
      //   _this.list[event] = [fn]
      // }
      _this.list[event] = [fn]
      return _this
    },
    emit: function(a, b) {
      let _this = this
      // 第一个参数是对应的 event 值，直接用数组的 shift 方法取出
      let event = [].shift.call(arguments),
        fns = [..._this.list[event]]
      // 如果缓存列表里没有 fn 就返回 false
      if (!fns || fns.length === 0) {
        return false
      }
      // 遍历 event 值对应的缓存列表，依次执行 fn
      fns.forEach(fn => {
        fn.apply(_this, arguments)
      })
      return _this
    },
    row: {},
  }
  setFunction ({type, fn}) {
    this.eventEmitter.on(type, fn)
  }
  runFunction ({type, params}) {
    if (this.eventEmitter.list[type]) {
      this.eventEmitter.emit(type, params)
    }
  }

}
export default new Observer()
